export function formatNumber(num: any) {
  if (num === null || num === '') return '';
  if (isNaN(num)) return "";
  return parseFloat(num).toLocaleString();
}
